export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/8e8641da5546a83267ff7cb844712535.svg";